// src/components/common/NotFound.tsx

import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Home as HomeIcon, Block as BlockIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                minHeight: '60vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 2,
            }}
        >
            <Paper
                elevation={0}
                sx={{
                    p: { xs: 3, sm: 5 },
                    maxWidth: 500,
                    textAlign: 'center',
                    bgcolor: 'transparent',
                }}
            >
                <BlockIcon
                    sx={{
                        fontSize: { xs: 80, sm: 120 },
                        color: 'text.disabled',
                        mb: 2,
                    }}
                />

                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 700,
                        color: 'text.primary',
                        mb: 1,
                    }}
                >
                    404
                </Typography>

                <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
                    Страница не найдена
                </Typography>

                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    Возможно, страница была удалена, или у вас нет доступа к ней.
                </Typography>

                <Button
                    variant="contained"
                    startIcon={<HomeIcon />}
                    onClick={() => navigate('/dashboard')}
                >
                    На главную
                </Button>
            </Paper>
        </Box>
    );
};

export default NotFound;